var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_5432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_5432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89992 15.0834C3.2564 15.0834 2.70941 14.8573 2.25895 14.4052C1.80849 13.9531 1.58325 13.4042 1.58325 12.7584V9.96669H3.59992V0.900024H14.4333V12.7667C14.4333 13.4102 14.208 13.9572 13.7576 14.4077C13.3071 14.8581 12.7601 15.0834 12.1166 15.0834H3.89992ZM12.1151 13.5167C12.3272 13.5167 12.5055 13.4448 12.6499 13.3011C12.7944 13.1573 12.8666 12.9792 12.8666 12.7667V2.48336H5.18325V9.96669H11.3666V12.7667C11.3666 12.9792 11.4383 13.1573 11.5818 13.3011C11.7253 13.4448 11.903 13.5167 12.1151 13.5167ZM6.18325 5.30002V3.98336H11.8666V5.30002H6.18325ZM6.18325 7.63336V6.30002H11.8666V7.63336H6.18325ZM3.88325 13.5167H9.78325V11.5334H3.14992V12.7584C3.14992 12.9732 3.22214 13.1533 3.36659 13.2987C3.51103 13.444 3.68325 13.5167 3.88325 13.5167ZM3.88325 13.5167H3.14992H9.78325H3.88325Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.afde6e300bb9e328e58933247c1c3699.svg";
export { ForwardRef as ReactComponent };